import React from 'react';
import PropTypes from 'prop-types';

function ArrowIcon({ direction, color, className }) {
	// eslint-disable-next-line max-len
	const leftPath = "M-9.53674e-07 6.66666L6.66682 -5.72205e-06L8 1.33314L2.66635 6.66666L8 12.0002L6.66682 13.3333L-9.53674e-07 6.66666Z";
	const rightPath = "M8 6.66666L1.33318 13.3333L0 12L5.33365 6.66666L0 1.33314L1.33318 -5.72205e-06L8 6.66666Z";
	
	return (
		<svg 
			width="16" 
			height="16" 
			viewBox="0 0 8 14" 
			fill="none" 
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path 
				d={direction === 'left' ? leftPath : rightPath} 
				fill={color} 
			/>
		</svg>
	);
}

ArrowIcon.propTypes = {
	direction: PropTypes.oneOf(['left', 'right']),
	color: PropTypes.string,
	className: PropTypes.string,
};

ArrowIcon.defaultProps = {
	direction: 'left',
	color: 'currentColor',
	className: '',
};

export default ArrowIcon;
